<template>
<div>
    <!-- <nav class="header-navbar navbar-expand-md navbar navbar-with-menu navbar-static-top navbar-light navbar-border navbar-brand-center" style="background:#fff">
      <img alt="logo" src="assets/images/UGLOGO.png" style="display:block;margin:auto;max-width:100%;max-height:60px" class="img img-responsive">
    </nav> -->
    <header class="bg-image-full" style="background-image: url(assets/images/bg.png);background-repeat: no-repeat;background-size:contain;background-attachment: fixed;padding-bottom:5rem !important;padding-top: 10rem !important">
    </header>
</div>
</template>

<script>
export default {
  name: 'Top'
}
</script>
<style scoped>

</style>

